module.exports = __webpack_public_path__ + "static/media/drake_img_1.c73870cd.png";